let backendHost = '';
let authHost="https://auth.businessonboarding.standardbank.co.za";

const hostname = window && window.location && window.location.hostname;

if(hostname === 'localhost') {
    authHost='https://auth-dgbksit.union.standardbank.co.za'
} else if(hostname === 'ao-dgbksit.union.standardbank.co.za') {
    authHost='https://auth-dgbksit.union.standardbank.co.za'
}

export const API_ROOT = `${backendHost}`;
export const AUTH_URL= `${authHost}`;
